import ChartTile from './ChartTile.jsx';
import TableTile from './TableTile.jsx';
import SingleValueTile from './SingleValueTile.jsx';
import BarGaugeTile from './BarGaugeTile.jsx';

// Picks the renderer for a tile's Looker vis type and hands it the result rows.
// Extracted from TileFrame so the PUBLIC share page (/r/:token) renders a shared
// tile exactly as the logged-in app does, without pulling the whole authenticated
// tile chrome (alerts, goals, segments, the Owl) into the public bundle.
export default function TileContent({ tile, data, zoom = 0 }) {
  const visType = tile.vis?.type;

  if (visType === 'single_value' || visType === 'single_value_period_over_period') {
    return <SingleValueTile data={data} visConfig={tile.vis} label={tile.title} />;
  }
  if (visType && visType.includes('bar_gauge')) {
    return <BarGaugeTile data={data} visConfig={tile.vis} label={tile.title} />;
  }
  // Charts and tables also get the tile's QUERY, so rows/series can follow the
  // order Looker was asked for (and read in sales-phase order when it wasn't) —
  // see lib/lookerOrder.js. Single-value/bar-gauge tiles read one row, so they
  // deliberately keep the raw order.
  if (visType === 'looker_grid' || visType === 'table' || visType === 'looker_legacy_table') {
    return <TableTile data={data} visConfig={tile.vis} query={tile.query} />;
  }
  if (
    visType === 'looker_column' || visType === 'looker_bar' || visType === 'looker_line' ||
    visType === 'looker_area' || visType === 'looker_scatter' || visType === 'looker_pie' ||
    visType === 'looker_donut_multiples'
  ) {
    return <ChartTile data={data} visConfig={tile.vis} zoom={zoom} query={tile.query} />;
  }
  // Fallback: always show the data.
  return <TableTile data={data} visConfig={tile.vis} query={tile.query} />;
}
